/**
   * Search results pre-fetch products
   */
function checkAndFetchProducts(bpData, resultsConfig) {
  bpData = JSON.parse(bpData)
  resultsConfig = JSON.parse(resultsConfig)
  console.log('running pre check')
    var now = Date.now();
    var useFreshData = resultsConfig ? resultsConfig.fresh : false;
    var PRODUCTS_DATA_ENDPOINT = useFreshData
      ? "/api/products"
      : "/dist/rsp/data/products.json";
    // need to determine how long it's safe to cache product data on the client-side
    // set to 60 mins (60s * 60) for now
    var SHELF_LIFE = 60 * 60;
    if (!(bpData &&
      bpData.products &&
      bpData.timestamp &&
      Math.floor((now - bpData.timestamp) / 1000) < SHELF_LIFE)) {
        console.log('running pre fetch')
        fetch(PRODUCTS_DATA_ENDPOINT)
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var products = data.products;
            postMessage(products)
        });
      }
  }

  addEventListener('message', function(event) {
    checkAndFetchProducts(event.data[0], event.data[1]);
  }, { passive: true});
